import * as React from 'react'
import CircularProgress from '@material-ui/core/CircularProgress'
import Typography from '@material-ui/core/Typography'
import Box from '@material-ui/core/Box'
import styles from './style.module.scss'
import { useSelector } from 'react-redux'
import { RootState } from 'src/store'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
function CircularProgressWithLabel(props) {
  const loadingProgress = useSelector(
    (state: RootState) => state?.loading?.progress
  )

  return (
    <Box className={styles.progressBar}>
      {loadingProgress === 100 ? (
        <CircularProgress />
      ) : (
        <>
          <CircularProgress variant="determinate" {...props} />
          <Box className={styles.box}>
            <Typography
              variant="caption"
              component="div"
              className={styles.typograph}
            >{`${loadingProgress}%`}</Typography>
          </Box>
        </>
      )}
    </Box>
  )
}

export const CircularStatic = () => {
  const loadingProgress = useSelector(
    (state: RootState) => state?.loading?.progress
  )

  return <CircularProgressWithLabel value={loadingProgress} />
}
